import { ServiceBagServices } from '@base/component/ServiceBag';
import { ServiceBagService } from '@base/component/ServiceBag';
import { BaseGridComponent } from '@base/component/BaseGridComponent';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseState } from '@m4u-angular/base/entities/BaseEntities';
import { DocumentLine } from '@dato-proxy/entities/documentline.entity';

class State extends BaseState {
    SelectedLineIDs: number[];
    TotalAmount: number;
}
@Component({
    providers: ServiceBagServices,
    selector: 'app-document-line-grid',
    templateUrl: './document-line-grid.component.html',
    styleUrls: ['./document-line-grid.component.scss']
})
export class DocumentLineGridComponent extends BaseGridComponent<DocumentLine, State> {

    @Output() SelectedLineIDsChange: EventEmitter<DocumentLine[]> = new EventEmitter<DocumentLine[]>();
    @Output() OnAfterLoad: EventEmitter<void> = new EventEmitter<void>();

    constructor(A: ServiceBagService) {
        super(A, 'DocumentLineGridComponent', DocumentLine, State);
    }

    override OnInitComponentFinished() {
        super.OnInitComponentFinished();
        this.State.SelectedLineIDs = (this.DataSource as DocumentLine[]).filter(x => x.IsOpen).map(x => (x as any).LineID);
    }

    OnContentReady() {
        this.OnAfterLoad.emit();
    }

    OnSelectionChanged(e) {
        if (e && e.selectedRowsData) {
            this.SelectedLineIDsChange.emit(e.selectedRowsData as DocumentLine[]);
            this.State.TotalAmount = (e.selectedRowsData as DocumentLine[]).map(x => x.TotalSum).reduce((sum, current) => sum + current, 0);
            return;
        }
    }

    get Currency() {
        const documentLines = this.DataSource as DocumentLine[];
        return documentLines?.length && documentLines[0].Currency;
    }
}
